export const TP_NUM = "TP_NUM";
export const TP_TEXT = "TP_TEXT";
export const TP_DATE = "TP_DATE";
export const COMBO = "COMBO";
export const SELECT = "SELECT";
export const SEARCH = "SEARCH";
export const SEARCH_BIT = "SEARCH_BIT";
